import { updateDoc, doc, serverTimestamp } from "firebase/firestore";
import { getFirestore } from "firebase/firestore";
import { app } from "../../firebase-config.js";
import { locale } from "../../services/LocaleService.js";

const db = getFirestore(app);

export class TermsAgreementModal {
    constructor(user, onComplete) {
        this.user = user;
        this.onComplete = onComplete;
        this.wrapper = null;
        this.state = {
            terms: false,
            privacy: false,
            marketing: false
        };
    }

    render() {
        if (document.getElementById('terms-modal')) return;

        const modalHtml = `
            <div id="terms-modal" class="fixed inset-0 z-[2000] flex items-center justify-center bg-black/80 backdrop-blur-md animate-fade-in p-4">
                <div class="bg-gray-900/90 border border-white/10 rounded-2xl w-full max-w-sm overflow-hidden shadow-2xl scale-95 opacity-0 transition-all duration-300" id="terms-modal-box">
                    
                    <!-- Header -->
                    <div class="p-6 text-center border-b border-white/5">
                        <h3 class="text-xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-violet-400 to-cyan-400 mb-2">
                            ${locale.t('terms.title')}
                        </h3>
                        <p class="text-xs text-gray-400">
                            ${locale.t('terms.desc')}
                        </p>
                    </div>

                    <!-- Checklist -->
                    <div class="p-6 space-y-4">
                        <!-- 1. Terms -->
                        <div class="flex items-start gap-3">
                            <div class="relative flex items-center">
                                <input type="checkbox" id="chk-terms" class="peer h-5 w-5 cursor-pointer appearance-none rounded-md border border-gray-600 bg-gray-800 transition-all checked:border-violet-500 checked:bg-violet-500">
                                <span class="pointer-events-none absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 text-white opacity-0 peer-checked:opacity-100">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-3.5 w-3.5" viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" /></svg>
                                </span>
                            </div>
                            <div class="flex-1">
                                <label for="chk-terms" class="text-sm text-gray-300 cursor-pointer select-none">
                                    <span class="text-violet-400 font-bold">${locale.t('terms.required')}</span> 
                                    <a href="https://ssulwha.world/terms.html" target="_blank" class="hover:text-white underline decoration-gray-600 underline-offset-2 transition-colors ml-1" id="link-terms">${locale.t('terms.label_terms')}</a>
                                </label>
                            </div>
                        </div>

                        <!-- 2. Privacy -->
                        <div class="flex items-start gap-3">
                            <div class="relative flex items-center">
                                <input type="checkbox" id="chk-privacy" class="peer h-5 w-5 cursor-pointer appearance-none rounded-md border border-gray-600 bg-gray-800 transition-all checked:border-violet-500 checked:bg-violet-500">
                                <span class="pointer-events-none absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 text-white opacity-0 peer-checked:opacity-100">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-3.5 w-3.5" viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" /></svg>
                                </span>
                            </div>
                            <div class="flex-1">
                                <label for="chk-privacy" class="text-sm text-gray-300 cursor-pointer select-none">
                                    <span class="text-violet-400 font-bold">${locale.t('terms.required')}</span> 
                                    <a href="https://ssulwha.world/privacy.html" target="_blank" class="hover:text-white underline decoration-gray-600 underline-offset-2 transition-colors ml-1" id="link-privacy">${locale.t('terms.label_privacy')}</a>
                                </label>
                            </div>
                        </div>

                        <!-- 3. Marketing -->
                        <div class="flex items-start gap-3">
                             <div class="relative flex items-center">
                                <input type="checkbox" id="chk-marketing" class="peer h-5 w-5 cursor-pointer appearance-none rounded-md border border-gray-600 bg-gray-800 transition-all checked:border-gray-500 checked:bg-gray-500">
                                <span class="pointer-events-none absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 text-white opacity-0 peer-checked:opacity-100">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-3.5 w-3.5" viewBox="0 0 20 20" fill="currentColor"><path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" /></svg>
                                </span>
                            </div>
                            <div class="flex-1">
                                <label for="chk-marketing" class="text-sm text-gray-400 cursor-pointer select-none hover:text-gray-300 transition-colors">
                                    <span class="text-gray-500 font-bold">${locale.t('terms.optional')}</span> ${locale.t('terms.label_marketing')}
                                </label>
                            </div>
                        </div>
                    </div>

                    <!-- Footer -->
                    <div class="p-6 pt-0">
                        <button id="btn-agree-start" disabled class="w-full py-3.5 rounded-xl font-bold transition-all duration-200 bg-gray-800 text-gray-500 cursor-not-allowed border border-gray-700">
                            ${locale.t('terms.btn_start')}
                        </button>
                    </div>

                </div>
            </div>
        `;

        this.wrapper = document.createElement('div');
        this.wrapper.innerHTML = modalHtml;
        document.body.appendChild(this.wrapper);

        this._bindEvents();
        this._show();
    }

    _show() {
        const box = this.wrapper.querySelector('#terms-modal-box');
        requestAnimationFrame(() => {
            box.classList.remove('scale-95', 'opacity-0');
            box.classList.add('scale-100', 'opacity-100');
        });
    }

    _close() {
        const box = this.wrapper.querySelector('#terms-modal-box');
        box.classList.remove('scale-100', 'opacity-100');
        box.classList.add('scale-95', 'opacity-0');
        setTimeout(() => {
            this.wrapper.remove();
            if (this.onComplete) this.onComplete();
        }, 300);
    }

    _bindEvents() {
        const wrapper = this.wrapper;
        const btnStart = wrapper.querySelector('#btn-agree-start');
        const chkTerms = wrapper.querySelector('#chk-terms');
        const chkPrivacy = wrapper.querySelector('#chk-privacy');
        const chkMarketing = wrapper.querySelector('#chk-marketing');

        const updateButtonState = () => {
            const isReady = chkTerms.checked && chkPrivacy.checked;
            if (isReady) {
                btnStart.disabled = false;
                btnStart.className = "w-full py-3.5 rounded-xl font-bold transition-all duration-200 bg-gradient-to-r from-violet-600 to-indigo-600 text-white shadow-lg shadow-violet-900/30 hover:shadow-violet-900/50 hover:scale-[1.02] active:scale-[0.98] border border-transparent";
            } else {
                btnStart.disabled = true;
                btnStart.className = "w-full py-3.5 rounded-xl font-bold transition-all duration-200 bg-gray-800 text-gray-500 cursor-not-allowed border border-gray-700";
            }

            this.state.terms = chkTerms.checked;
            this.state.privacy = chkPrivacy.checked;
            this.state.marketing = chkMarketing.checked;
        };

        const handleLinkClick = (e, url) => {
            e.preventDefault(); // Prevent default if needed, or allow default (new tab) logic
            e.stopPropagation(); // Stop bubbling to label
            // The <a> tag already has target="_blank" and href. 
            // We can just confirm logic or let it be.
            // Requirement: "Click text -> Open URL". 
            // The HTML structure puts <a> inside <label>. 
            // If user clicks <a>, it opens URL. 
            // If user clicks <label> outside <a>, it toggles checkbox.
            // This is correct behavior.
            window.open(url, '_blank');
        };

        // Explicit link handling to be safe
        wrapper.querySelector('#link-terms').onclick = (e) => handleLinkClick(e, 'https://mirinae-platform.web.app/terms.html');
        wrapper.querySelector('#link-privacy').onclick = (e) => handleLinkClick(e, 'https://mirinae-platform.web.app/privacy.html');

        chkTerms.onchange = updateButtonState;
        chkPrivacy.onchange = updateButtonState;
        chkMarketing.onchange = updateButtonState;

        btnStart.onclick = async () => {
            // Save to Firestore
            try {
                btnStart.textContent = locale.t('terms.btn_processing');
                btnStart.disabled = true;

                await updateDoc(doc(db, "users", this.user.uid), {
                    terms_agreed: true,
                    terms_agreed_at: serverTimestamp(),
                    marketing_agreed: this.state.marketing
                });

                this._close();

            } catch (e) {
                console.error("Terms Agreement Error:", e);
                alert(locale.t('login.err_default'));
                btnStart.textContent = locale.t('terms.btn_start');
                btnStart.disabled = false;
            }
        };
    }
}
